import { Route } from 'react-router-dom';
import { Navigate } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { Layout } from 'components/layout';
import FacebookPage from '../pages/facebook';
import TikTokPage from '../pages/tiktok';
import TwitterPage from '../pages/twitter';
import PinterestPage from '../pages/pinterest';

const ServicesRouter = (
  <Route path="/services">
    <Route index element={<Navigate to="facebook" />} />
    <Route
      path="facebook"
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <Layout title="Facebook Ads Automation">
            <FacebookPage />
          </Layout>
        </QueryParamProvider>
      }
    />
    <Route
      path="tiktok"
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <Layout title="TikTok Ads Automation">
            <TikTokPage />
          </Layout>
        </QueryParamProvider>
      }
    />
    <Route
      path="twitter"
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <Layout title="X Ads Automation">
            <TwitterPage />
          </Layout>
        </QueryParamProvider>
      }
    />
    <Route
      path="pinterest"
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <Layout title="Pinterest Ads Automation">
            <PinterestPage />
          </Layout>
        </QueryParamProvider>
      }
    />
    <Route path="*" element={<Navigate to="/facebook" />} />
  </Route>
);

export default ServicesRouter;